import { a as __rest } from '../../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useCardContext } from '../Card.context.esm.js';
import { useCardImage } from '../CardHooks.esm.js';
import imageStyles from './CardImage.styles.esm.js';
import { cn } from '../../../utils/cn.esm.js';

const CardImage = (_a) => {
    var _b;
    var { className, children } = _a, imageProps = __rest(_a, ["className", "children"]);
    const { imagePosition } = useCardContext();
    const styles = imageStyles({ imagePosition });
    const containerClass = cn(styles.imageContainer(), className);
    const imageClass = styles.image();
    // Always call the hook (Rules of Hooks) then decide what to render
    const rendered = useCardImage(imageProps, cn(styles.image()));
    let content = null;
    if (children) {
        if (React__default.isValidElement(children)) {
            // Merge className vào element con
            content = React__default.cloneElement(children, {
                className: cn(imageClass, ((_b = children.props) === null || _b === void 0 ? void 0 : _b.className) || ""),
            });
        }
        else {
            // Wrap các kiểu primitive / list
            content = jsx("div", { className: imageClass, children: children });
        }
    }
    else {
        content = rendered;
    }
    if (!content)
        return null;
    return (jsx("div", { className: containerClass, style: { width: imageProps.width, height: imageProps.height }, children: content }));
};
CardImage.__CARD_IMAGE = true;
CardImage.displayName = "CardImage";

export { CardImage };
